import { useEffect, useState } from "react";
import { get_arqueadorescaja } from "../../../../../actions/caja";
import { SearchBasicSelectUI } from "../../../../ui";

export const ArqueadoresCajaSelect = ({ ...props }) => {
  const [arqueadores, setArqueadores] = useState([]);
  useEffect(() => {
    const OnLoadArqueadoresCaja = async () => {
      const _data = await get_arqueadorescaja();
      setArqueadores(_data);
    };
    OnLoadArqueadoresCaja();
    return () => {
      setArqueadores([]);
    };
  }, []);

  return <SearchBasicSelectUI data={arqueadores} {...props} />;
};
